var map = {
	"./img/404.png": 19,
	"./img/about-2-bg-cut.png": 46,
	"./img/about-2-bg.png": 21,
	"./img/about-2.jpg": 47,
	"./img/about-btc.jpg": 48,
	"./img/about.jpg": 22,
	"./img/banner-poster.jpg": 49,
	"./img/blog/01.jpg": 50,
	"./img/blog/Bitcoin-Accounting.png": 51,
	"./img/blog/LN-course-blog.png": 52,
	"./img/blog/bitcoin-vs-SWIFT.png": 53,
	"./img/blog/utxo-wallet.png": 54,
	"./img/brand-logo/01.png": 55,
	"./img/brand-logo/02.png": 56,
	"./img/brand-logo/03.png": 57,
	"./img/brand-logo/04.png": 58,
	"./img/brand-logo/05.png": 59,
	"./img/brand-logo/Blockstream_small.png": 60,
	"./img/brand-logo/bitgo-small.png": 61,
	"./img/brand-logo/btcpay-small.png": 62,
	"./img/brand-logo/kubernetes_small.png": 63,
	"./img/brand-logo/lnd-logo-small.png": 64,
	"./img/brand-logo/react-native-small.png": 65,
	"./img/brand-logo/rust_lang_small.png": 66,
	"./img/brand-logo/trezor-small.png": 67,
	"./img/demo-page/bootstrap.png": 68,
	"./img/demo-page/code.png": 69,
	"./img/demo-page/coming-soon.jpg": 70,
	"./img/demo-page/document.png": 71,
	"./img/demo-page/fontawesome.png": 72,
	"./img/demo-page/google-font.png": 73,
	"./img/demo-page/jquery.png": 74,
	"./img/demo-page/pages/about.jpg": 75,
	"./img/demo-page/pages/blog-details-sidebar.jpg": 76,
	"./img/demo-page/pages/blog-details.jpg": 77,
	"./img/demo-page/pages/blog-grid.jpg": 78,
	"./img/demo-page/pages/blog-l-g.jpg": 79,
	"./img/demo-page/pages/blog-l-l.jpg": 80,
	"./img/demo-page/pages/blog-l-r.jpg": 81,
	"./img/demo-page/pages/blog-r-g.jpg": 82,
	"./img/demo-page/pages/contact.jpg": 83,
	"./img/demo-page/pages/home-1.jpg": 84,
	"./img/demo-page/pages/home-2.jpg": 85,
	"./img/demo-page/pages/service-details.jpg": 86,
	"./img/demo-page/pages/service.jpg": 87,
	"./img/demo-page/pages/team-details.jpg": 88,
	"./img/demo-page/pages/team.jpg": 89,
	"./img/demo-page/react.svg": 90,
	"./img/demo-page/responsive.png": 91,
	"./img/demo-page/sass.png": 92,
	"./img/demo-page/slick.jpg": 93,
	"./img/demo-page/slider-bg.jpg": 94,
	"./img/demo-page/speed.png": 95,
	"./img/demo-page/support.png": 96,
	"./img/favicon.ico": 97,
	"./img/feature/01-team.png": 98,
	"./img/feature/01.png": 99,
	"./img/feature/02.png": 100,
	"./img/feature/03.png": 101,
	"./img/fun-fact-bg.jpg": 23,
	"./img/icons/cancel-white.png": 24,
	"./img/icons/cancel.png": 102,
	"./img/icons/coloredbg.png": 103,
	"./img/icons/loader.gif": 104,
	"./img/icons/quote.png": 105,
	"./img/logo-dark.png": 25,
	"./img/logo-white.png": 106,
	"./img/logo.png": 20,
	"./img/page-header-bk.jpg": 107,
	"./img/page-header.jpg": 14,
	"./img/service/01.jpg": 108,
	"./img/service/02.jpg": 109,
	"./img/service/03.jpg": 110,
	"./img/service/04.jpg": 111,
	"./img/service/05.jpg": 112,
	"./img/service/06.jpg": 113,
	"./img/service/Benefits-of-Using-a-Cold-Storage-Wallet-small.jpg": 114,
	"./img/service/ProcessAutomation-small-700x600.jpg": 115,
	"./img/service/bitcoin-wallet-small.jpg": 116,
	"./img/service/bitcoin-wallet.jpg": 117,
	"./img/service/cross-border-payment-lightning-network.jpg": 118,
	"./img/service/cyber-security-small.jpg": 119,
	"./img/service/details/01.jpg": 120,
	"./img/service/details/02.jpg": 121,
	"./img/service/details/03.jpg": 122,
	"./img/service/flow-diagram-processes-planning.jpg": 123,
	"./img/service/icon/analysis.png": 124,
	"./img/service/icon/research.png": 125,
	"./img/service/icon/strategy.png": 126,
	"./img/service/icon/track-record.png": 127,
	"./img/service/service-bg.jpg": 26,
	"./img/slider/01-meeting-smile.jpg": 128,
	"./img/slider/01-sillon-cut.jpg": 129,
	"./img/slider/01.gif": 130,
	"./img/slider/01.jpg": 131,
	"./img/slider/01.jpg.bkp": 132,
	"./img/slider/01.png-rocket": 133,
	"./img/slider/02.jpg": 134,
	"./img/slider/h-2-01.jpg": 135,
	"./img/slider/h-2-02.jpg": 136,
	"./img/team/01.jpg": 137,
	"./img/team/02.jpg": 138,
	"./img/team/03.jpg": 139,
	"./img/team/04.jpg": 140,
	"./img/team/05.jpg": 141,
	"./img/team/06.jpg": 142,
	"./img/team/ceo.png": 143,
	"./img/team/details/date-1.png": 144,
	"./img/team/details/date-2.png": 145,
	"./img/team/details/date-3.png": 146,
	"./img/team/h-2-01-bk.png": 147,
	"./img/team/h-2-01.png": 148,
	"./img/team/h-2-02.png": 149,
	"./img/team/h-2-03.png": 150,
	"./img/team/h-2-04.png": 151,
	"./img/team/team-arrow-1.png": 152,
	"./img/team/team-arrow.png": 153,
	"./img/team/team-bg-2-bk.jpg": 154,
	"./img/team/team-bg-2.jpg": 27,
	"./img/team/team-bg.jpg": 155,
	"./img/team/team-details.jpg": 156,
	"./img/testimonial/bg-dot.png": 157,
	"./img/testimonial/client-01.jpg": 158,
	"./img/testimonial/client-02.jpg": 159,
	"./img/testimonial/client-03.jpg": 160,
	"./img/testimonial/h-2-t-01.png": 161,
	"./img/testimonial/h-2-t-02.png": 162,
	"./img/testimonial/h-2-t-03.png": 163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 220;